import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import {
  TIME_SLOTS,
  WORK_DAYS,
  ALBASTAR_TIME_SLOTS,
  PANATCH_WORK_DAYS,
  PANATCH_TIME_SLOTS,
} from 'src/common/constants';
import FontAwesomeIcon from '../Icon';
import Input from '../Input';
import Callout from 'src/components/InformationCallout/Callout';
import { toast } from 'react-toastify';
import './TimeSlot.scss';

interface TimeSlotProps {
  fromScheduling?: any;
  handleSelectionFormData: (selection: string) => void;
  from?: string;
  serviceRequestForm?: boolean;
}

const TimeSlot = ({
  fromScheduling,
  handleSelectionFormData,
  from,
  serviceRequestForm,
}: TimeSlotProps) => {
  const selectedSlots = (data: any) => {
    let slots: any[] = [];

    data.forEach((item: any) =>
      item.slots.forEach((value: any) => {
        slots.push(item.day + ' ' + value);
      })
    );

    return slots;
  };

  const [state, setState] = useState({
    tab: 'Monday',
    selection: fromScheduling
      ? fromScheduling.length > 0
        ? selectedSlots(fromScheduling)
        : []
      : [],
    filterTab: null,
    filterDay: [],
    otherValue: null,
    otherSelected: false,
  });

  const handleSelection = (slot: string) => {
    setState((prev) => ({ ...prev, otherSelected: false, otherValue: '' }));
    const { selection, tab, otherValue } = state;

    let selections: any[] = [];
    let tempSelections: any[] = [];

    tempSelections = selection.filter((s: any) => s.includes(`${tab} Other: `));

    if (tempSelections.length > 0) {
      let temprorySelection: any[] = [];
      let localSelections: any[] = [];

      localSelections = selection.map((slot: any) => {
        if (slot.includes(`${tab} Other: `)) {
          return null;
        } else {
          return slot;
        }
      });

      temprorySelection = localSelections.filter((s: any) => s !== null);

      if (temprorySelection.includes(slot)) {
        selections = temprorySelection.filter((s: any) => s !== slot);
      } else {
        selections = [...temprorySelection, slot];
      }

      setState((prev) => ({ ...prev, selection: selections }));
      handleSelectionFormData(selections.join(','));
    } else {
      if (selection.includes(slot)) {
        selections = selection.filter((s: any) => s !== slot);
      } else {
        selections = [...selection, slot];
      }

      setState((prev) => ({ ...prev, selection: selections }));
      handleSelectionFormData(selections.join(','));
    }
  };

  const handleOther = (tab: string) => {
    setState((prev) => ({ ...prev, otherSelected: true, otherValue: null }));
    const { selection } = state;
    let tempSelections: any[] = [];
    let selections: any[] = [];

    tempSelections = selection.map((slot: any) => {
      if (slot.includes(tab)) {
        return null;
      } else {
        return slot;
      }
    });

    selections = tempSelections.filter((s: any) => s !== null);
    setState((prev) => ({ ...prev, selection: selections }));
    handleSelectionFormData(selections.join(','));
  };

  const handleOtherInput = ({
    tab,
    otherValue,
  }: {
    tab: string;
    otherValue: string;
  }) => {
    const { selection } = state;

    let day = tab;
    let selections: any[] = [];
    let tempSelections: any[] = [];

    tempSelections = selection.filter((s: any) => s.includes(`${tab} Other: `));

    if (tempSelections.length > 0) {
      let temprorySelection: any[] = [];
      let localSelections: any[] = [];
      localSelections = selection.map((slot: any) => {
        if (slot.includes(`${tab} Other: `)) {
          return null;
        } else {
          return slot;
        }
      });
      temprorySelection = localSelections.filter((s: any) => s !== null);
      temprorySelection = [...temprorySelection, `${tab} Other: ${otherValue}`];

      handleSelectionFormData(temprorySelection.join(','));

      setState((prev) => ({
        ...prev,
        otherSelected: true,
        tab: day,
        selection: temprorySelection,
        otherValue: otherValue,
      }));
    } else {
      selections = [...selection, `${tab} Other: ${otherValue}`];
      handleSelectionFormData(selections.join(','));

      setState((prev) => ({
        ...prev,
        otherSelected: true,
        tab: day,
        selection: selections,
        otherValue: otherValue,
      }));
    }
  };

  const handleDay = (day: string) => {
    const { otherSelected, selection, otherValue, tab } = state;

    let tempSelections: any[] = [];
    tempSelections = selection.filter((s: any) => s.includes(`${day} Other: `));

    if (tempSelections.length > 0) {
      let tempText = tempSelections[0];
      let otherValue = tempText.replace(`${day} Other: `, '');

      setTimeout(() => {
        setState((prev) => ({
          ...prev,
          otherSelected: true,
          otherValue: otherValue,
        }));
      }, 500);
    }

    let selections: any[] = [];

    if (otherSelected && (otherValue === '' || otherValue === null)) {
      toast.error(` 🚫 Other field is required.`, {
        autoClose: 12000,
        position: 'top-center',
      });
    } else if (otherSelected && (otherValue !== '' || otherValue !== null)) {
      let tempSelections: any[] = [];
      tempSelections = selection.filter((s: any) =>
        s.includes(`${tab} Other: `)
      );

      if (tempSelections.length > 0) {
        let temprorySelection: any[] = [];
        let localSelections: any[] = [];

        localSelections = selection.map((slot: any) => {
          if (slot.includes(`${tab} Other: `)) {
            return null;
          } else {
            return slot;
          }
        });

        temprorySelection = localSelections.filter((s: any) => s !== null);
        temprorySelection = [
          ...temprorySelection,
          `${tab} Other: ${otherValue}`,
        ];

        handleSelectionFormData(temprorySelection.join(','));

        setState((prev) => ({
          ...prev,
          otherSelected: false,
          tab: day,
          selection: temprorySelection,
          otherValue: null,
        }));
      } else {
        selections = [...selection, `${tab} Other: ${otherValue}`];
        handleSelectionFormData(selections.join(','));

        setState((prev) => ({
          ...prev,
          otherSelected: false,
          tab: day,
          selection: selections,
          otherValue: null,
        }));
      }
    } else {
      setState((prev) => ({ ...prev, tab: day }));
    }
  };

  useEffect(() => {
    const theme = localStorage.getItem('theme');

    if (fromScheduling && fromScheduling.length > 0) {
      handleSelectionFormData(state.selection.join(','));
    }

    const isSchedulingView =
      from === 'srscheduling' && theme !== 'Rize' && theme !== 'Formwerks';

    if (!isSchedulingView) {
      return;
    }

    /* Guard: some tenants (e.g. Wesgroup) send an empty preferredServiceTimes list.
     * Bail before reading fromScheduling[0] so we render the error state below
     * instead of crashing on undefined. Root cause is upstream (the API shouldn't
     * return an empty list here) — warn so it's observable, not silently swallowed. */
    if (!Array.isArray(fromScheduling) || fromScheduling.length === 0) {
      console.warn(
        'TimeSlot: srscheduling view received an empty preferredServiceTimes list; rendering error state.'
      );
      return;
    }

    const workDays = theme === 'Panatch' ? PANATCH_WORK_DAYS : WORK_DAYS;

    const filterDay: any[] = [];

    workDays.forEach((dayItem: any) => {
      fromScheduling.forEach((preferedDayItem: any) => {
        const isMatchingDay: boolean =
          dayItem === preferedDayItem.day &&
          !filterDay.includes(preferedDayItem.day);

        if (isMatchingDay) {
          filterDay.push(preferedDayItem.day);
        }
      });
    });

    setState((prev: any) => ({
      ...prev,
      filterTab: fromScheduling[0].day,
      filterDay,
    }));
  }, []);

  const { tab, selection, filterTab } = state;

  let theme: string = localStorage.getItem('theme');

  let slots: string[] =
    theme === 'Albaster'
      ? ALBASTAR_TIME_SLOTS
      : theme === 'Panatch'
        ? PANATCH_TIME_SLOTS
        : TIME_SLOTS;

  let days: string[] = theme === 'Panatch' ? PANATCH_WORK_DAYS : WORK_DAYS;
  let disableForSchedule: boolean = false;

  const isSchedulingView: boolean =
    from === 'srscheduling' && theme !== 'Rize' && theme !== 'Formwerks';

  const hasSchedulingData: boolean =
    Array.isArray(fromScheduling) && fromScheduling.length > 0;

  // A bad/empty preferredServiceTimes payload leaves nothing to schedule against —
  // show a graceful message rather than an empty (or crashed) picker.
  const showSchedulingError: boolean = isSchedulingView && !hasSchedulingData;

  return (
    <div className="timeSlot">
      <div className="timeSlot__require">
        <div className="timeSlot__label">Homeowner Availability</div>
        <div className="timeSlot__required" />
      </div>
      {serviceRequestForm ? (
        <div>Please indicate what days and times might work for you.</div>
      ) : null}
      <br />
      <br />
      <div className="timeSlot__control">
        {from === 'srscheduling' ? (
          theme !== 'Rize' && theme !== 'Formwerks' ? (
            showSchedulingError ? (
              <Callout
                variant="error"
                title="We couldn't load scheduling times"
                subtitle="It doesn't look like there are any valid time slots to schedule for this request. If this doesn't look right, please contact support."
              />
            ) : (
            <>
              <div className="timeSlot__tabs">
                {state.filterDay.map((day: any) => (
                  <button
                    type="button"
                    key={day}
                    onClick={() =>
                      setState((prev: any) => ({ ...prev, filterTab: day }))
                    }
                    className={classNames('timeSlot__tab', {
                      'timeSlot__tab--active': day === filterTab,
                    })}
                  >
                    {day}
                  </button>
                ))}
              </div>
              <div className="timeSlot__days">
                {state.selection.map((selected: any) =>
                  selected.includes(filterTab) ? (
                    <button
                      type="button"
                      className={classNames('timeSlot__slot', {
                        'timeSlot__slot--active':
                          selection.indexOf(selected) > -1,
                      })}
                    >
                      <div className="timeSlot__bullet">
                        <FontAwesomeIcon glyph="check" weight="regular" />
                      </div>
                      {selected.replace(filterTab, '')}
                    </button>
                  ) : null
                )}
              </div>
            </>
            )
          ) : null
        ) : (
          <>
            <div className="timeSlot__tabs">
              {days.map((day: any) => (
                <button
                  type="button"
                  key={day}
                  onClick={() => handleDay(day)}
                  className={classNames('timeSlot__tab', {
                    'timeSlot__tab--active': day === tab,
                  })}
                >
                  {day}
                </button>
              ))}
            </div>
            <div className="timeSlot__days">
              {slots.map((slot: any) => (
                <button
                  type="button"
                  key={tab + ' ' + slot}
                  onClick={() =>
                    slot === 'Other:'
                      ? handleOther(tab)
                      : disableForSchedule
                        ? {}
                        : handleSelection(tab + ' ' + slot)
                  }
                  className={classNames('timeSlot__slot', {
                    'timeSlot__slot--active':
                      slot === 'Other:'
                        ? state.otherSelected
                        : selection.indexOf(tab + ' ' + slot) > -1,
                  })}
                  style={slot === 'Other:' ? { backgroundColor: 'White' } : {}}
                >
                  <div className="timeSlot__bullet">
                    <FontAwesomeIcon glyph="check" weight="regular" />
                  </div>
                  {slot}
                  {slot === 'Other:' && (
                    <div style={{ marginTop: '30px' }}>
                      &nbsp;&nbsp;{' '}
                      <Input
                        value={state.otherValue}
                        onChange={(e: any) => {
                          setState((prev: any) => ({
                            ...prev,
                            otherValue: e?.target?.value,
                          }));
                          handleOtherInput({
                            tab,
                            otherValue: e?.target?.value,
                          });
                        }}
                        label={null}
                      />
                    </div>
                  )}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TimeSlot;
